var _a;
import { __assign, __makeTemplateObject, __read, __rest } from "tslib";
import React, { useState } from "react";
import { Box, Button, Checkbox, Chip, FormControl, FormControlLabel, IconButton, LinearProgress, MenuItem, Radio, RadioGroup, Select, Switch, TextField, Tooltip, Typography } from "@material-ui/core";
import { StylesProvider, ThemeProvider, useTheme } from "@material-ui/core/styles";
import { CameraAlt, Close, CloudUploadRounded, Delete } from "@material-ui/icons";
import { useDispatch } from "react-redux";
import styled from "styled-components";
import { Check, Plus } from "./CustomInput.Icons";
import { CustomInputType } from "./customInput.model";
import { generateClassName, useCustomInputStyles } from "./customInput.styles";
import { validateInput } from "./customInput.utils";
import { ERROR_FIELD_COLOR } from "../../constants";
import { uploadFile } from "../../utils/stateUtils";
import { MultipleCheckbox } from "../MultipleCheckbox";
import TinyMCE from "../TinyMCE";
import Uploader from "../Uploader";
export var FileTagContainer = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: space-between;\n\tbackground-color: ", ";\n\tborder-radius: 16px;\n\tpadding: 0 10px;\n"], ["\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: space-between;\n\tbackground-color: ", ";\n\tborder-radius: 16px;\n\tpadding: 0 10px;\n"])), function (_a) {
    var theme = _a.theme;
    return theme.palette.background.default;
});
var FileTag = function (_a) {
    var name = _a.name, onClose = _a.onClose;
    return (React.createElement(FileTagContainer, null,
        React.createElement(Box, null,
            React.createElement(Typography, { variant: "caption" }, name)),
        React.createElement(IconButton, { onClick: function (e) {
                e.stopPropagation();
                e.preventDefault();
                onClose();
            }, size: "small" },
            React.createElement(Delete, null))));
};
var textFieldInputTypeProps = (_a = {},
    _a[CustomInputType.Email] = { type: "email" },
    _a[CustomInputType.Multiline] = { multiline: true },
    _a[CustomInputType.Number] = { type: "number" },
    _a[CustomInputType.Password] = { type: "password" },
    _a[CustomInputType.Phone] = { type: "phone" },
    _a[CustomInputType.Text] = { type: "text" },
    _a);
export var CustomInput = function (_a) {
    var _b = _a.inputProps, inputProps = _b === void 0 ? {} : _b, _c = _a.InputProps, InputProps = _c === void 0 ? {} : _c, options = _a.options, containerClassName = _a.containerClassName, customTheme = _a.theme, containerProps = __rest(_a, ["inputProps", "InputProps", "options", "containerClassName", "theme"]);
    var boxBorderProps = {};
    var classes = useCustomInputStyles();
    var dispatch = useDispatch();
    var _d = __read(useState(0), 2), progress = _d[0], setProgress = _d[1];
    var _e = __read(useState(false), 2), isSelectOpen = _e[0], setIsSelectOpen = _e[1];
    var _f = __read(useState(false), 2), uploading = _f[0], setUploading = _f[1];
    var _emit = options._emit, genericApiService = options.genericApiService, inputData = options.inputData, plugins = options.plugins, setStateValue = options.setStateValue, validateForm = options.validateForm;
    var defaultValue = inputData.defaultValue, emptySelectOption = inputData.emptySelectOption, error = inputData.error, hasClearButton = inputData.hasClearButton, imageExtensionName = inputData.imageExtensionName, imageFileType = inputData.imageFileType, imageUrl = inputData.imageUrl, isImageFile = inputData.isImageFile, label = inputData.label, pristine = inputData.pristine, readonly = inputData.readonly, _g = inputData.selectOptions, selectOptions = _g === void 0 ? [] : _g, statePath = inputData.statePath, inputType = inputData.type, uploaderIconName = inputData.uploaderIconName, uploaderStateLoaderKey = inputData.uploaderStateLoaderKey, inputValue = inputData.value;
    var theme = customTheme || useTheme();
    var validations = __assign({}, (inputData.validations || {}));
    var validateInputOptions = {
        dispatch: dispatch,
        setStateValue: setStateValue,
        inputData: inputData,
        markAsDirty: true,
        validateForm: validateForm
    };
    var displayError = error !== null && !pristine;
    var chipsBottomAction = inputProps.chipsBottomAction, fileUploaderDescription = inputProps.fileUploaderDescription, onBlur = inputProps.onBlur, onChange = inputProps.onChange, onClose = inputProps.onClose, onKeyPress = inputProps.onKeyPress, uploaderWidth = inputProps.uploaderWidth, otherInputProps = __rest(inputProps, ["chipsBottomAction", "fileUploaderDescription", "onBlur", "onChange", "onClose", "onKeyPress", "uploaderWidth"]);
    var boxClassName = "";
    var input;
    var cb = function () {
        setUploading(false);
        setProgress(0);
    };
    switch (inputType) {
        case CustomInputType.Checkbox:
            input = (React.createElement(FormControl, { size: "small", variant: "filled", fullWidth: true },
                React.createElement(FormControlLabel, __assign({ control: React.createElement(Checkbox, __assign({}, otherInputProps, { disabled: !!readonly, color: "primary", checked: !!inputValue, onChange: function (e) {
                            validateInput(e.target.checked, validateInputOptions);
                            if (onChange) {
                                onChange(e);
                            }
                        } })), label: inputData.label }, (readonly ? { readonly: true } : {})))));
            break;
        case CustomInputType.Switch:
            input = (React.createElement(FormControl, { size: "small", variant: "filled", fullWidth: true },
                React.createElement(FormControlLabel, __assign({ control: React.createElement(Switch, __assign({}, otherInputProps, { disabled: !!readonly, checked: !!inputValue, onChange: function (e) {
                            validateInput(e.target.checked, validateInputOptions);
                            if (onChange) {
                                onChange(e);
                            }
                        }, name: "isVisible", inputProps: { "aria-label": "primary checkbox" }, classes: {
                            switchBase: classes.switchBase,
                            track: classes.track,
                            checked: classes.checked
                        } })), label: inputData.label }, (readonly ? { readonly: true } : {})))));
            break;
        case CustomInputType.CheckboxArray:
            input = (React.createElement(MultipleCheckbox, { className: containerClassName, selectOptions: selectOptions, otherInputProps: otherInputProps, readonly: readonly, values: inputValue, onChange: function (value) { return validateInput(value, validateInputOptions); } }));
            break;
        case CustomInputType.Chips:
            var namedOptionsMap_1 = {};
            var selectedOptionsMap_1 = {};
            if (inputValue instanceof Array && inputValue.length) {
                inputValue.forEach(function (item) { return (selectedOptionsMap_1[item] = true); });
            }
            var MenuItems = (emptySelectOption ? [emptySelectOption] : []).concat(selectOptions).map(function (option) {
                var value = option.value;
                namedOptionsMap_1[value] = option.text;
                return (React.createElement(MenuItem, { value: value, key: "".concat(value) },
                    React.createElement(Box, { width: "100%", display: "flex", justifyContent: "space-between", alignItems: "center" },
                        React.createElement(Box, null,
                            React.createElement(Box, { mb: -1 },
                                React.createElement(Typography, null, option.text)),
                            option.subtitle && React.createElement(Typography, { variant: "caption" }, option.subtitle)),
                        React.createElement(Box, { className: classes.optionCheckbox }, selectedOptionsMap_1[value] ? React.createElement(Check, { fontSize: "small" }) : React.createElement(Plus, { fontSize: "small" })))));
            });
            input = (React.createElement(FormControl, { size: "small", variant: "filled", fullWidth: true, hiddenLabel: true },
                React.createElement(Select, { value: inputValue, multiple: true, disableUnderline: true, displayEmpty: true, fullWidth: true, open: isSelectOpen, disabled: selectOptions.length === 0 || readonly, onOpen: function () {
                        setIsSelectOpen(true);
                    }, onChange: function (e) {
                        var value = e.target.value.filter(function (v) { return v; });
                        validateInput(value, __assign(__assign({}, validateInputOptions), { inputData: __assign(__assign({}, inputData), { validations: validations }) }));
                        if (onChange) {
                            onChange(e);
                        }
                    }, onClose: function () {
                        setIsSelectOpen(false);
                        if (onClose) {
                            onClose(inputValue);
                        }
                    }, renderValue: function (selected) {
                        if (selected.length === 0) {
                            return React.createElement("div", null, label || inputData.placeholder);
                        }
                        else {
                            return (React.createElement("div", { className: classes.chips }, selected ? (selected.map(function (value) { return (React.createElement(Chip, { color: "primary", size: "small", key: value, label: namedOptionsMap_1[value], className: classes.chip })); })) : (React.createElement(React.Fragment, null))));
                        }
                    } },
                    MenuItems,
                    chipsBottomAction && (React.createElement(MenuItem, { onClick: function (e) {
                            setIsSelectOpen(false);
                            e.preventDefault();
                            chipsBottomAction();
                        } },
                        React.createElement(Box, { py: 1, textAlign: "center", width: "100%" },
                            React.createElement(Typography, { className: classes.bottomLabel }, inputData.chipsBottomLabel)))))));
            break;
        case CustomInputType.File:
            boxClassName += classes.uploader;
            var imageExtensionArray = (imageExtensionName || "png").split(",").map(function (i) { return ".".concat(i.trim()); });
            input = (React.createElement(React.Fragment, null, typeof inputValue === "string" && inputValue.length ? (isImageFile ? (React.createElement(Box, { className: classes.cancelContainer },
                React.createElement(IconButton, { size: "small", className: classes.cancelThumbnail, onClick: function () {
                        validateInput("", validateInputOptions);
                        dispatch(setStateValue({ key: "".concat(statePath, ".imageUrl"), value: "" }));
                        dispatch(setStateValue({ key: "".concat(statePath, ".name"), value: "" }));
                        if (onChange) {
                            onChange({ target: { value: "" } });
                        }
                    } },
                    React.createElement(Close, { className: classes.cancelIcon })),
                React.createElement(Box, { className: "".concat(classes.imgContainer, "  ").concat(imageUrl ? classes.imgContainerBorder : "") },
                    React.createElement("img", { alt: "uploaded image", src: imageUrl, className: classes.image })))) : (React.createElement(FileTag, { onClose: function () {
                    validateInput("", validateInputOptions);
                    dispatch(setStateValue({ key: "".concat(statePath, ".imageUrl"), value: "" }));
                    dispatch(setStateValue({ key: "".concat(statePath, ".name"), value: "" }));
                    if (onChange) {
                        onChange({ target: { value: "" } });
                    }
                }, name: inputData.name }))) : (React.createElement(Box, { display: "flex", flexDirection: "column" },
                isImageFile ? (React.createElement(Uploader, { accept: imageExtensionArray, boxProps: { width: uploaderWidth || "246px", height: "246px" }, clearFileInputSubject: undefined, error: false, header: label || "Upload File", icon: uploaderIconName === "cloud-upload" ? (React.createElement(CloudUploadRounded, { name: "cloud-upload", style: { width: "50px", height: "50px", fill: "hsl(223,10%,58%)" } })) : (React.createElement(CameraAlt, { style: { width: "50px", height: "50px", fill: "hsl(223,10%,58%)" } })), loading: false, onAdd: function (e) {
                        if (e && e[0]) {
                            setUploading(true);
                            dispatch(uploadFile({ file: e[0] }, {
                                _emit: _emit,
                                genericApiService: genericApiService,
                                imageUrlStatePath: isImageFile ? "".concat(statePath, ".imageUrl") : undefined,
                                loaderStatePath: uploaderStateLoaderKey,
                                s3KeyStatePath: "".concat(statePath, ".value"),
                                setStateValue: setStateValue,
                                uploadCb: cb,
                                onProgress: function (_a) {
                                    var loaded = _a.loaded, total = _a.total;
                                    setProgress((loaded / total) * 100);
                                }
                            }));
                            if (onChange) {
                                onChange({ target: { value: inputValue } });
                            }
                        }
                        else {
                            validateInput(null, validateInputOptions);
                            if (onChange) {
                                onChange({ target: { value: "" } });
                            }
                        }
                    }, progress: progress, title: fileUploaderDescription || (React.createElement(React.Fragment, null,
                        "Drag and Drop File Here or Browse to Choose a File ",
                        React.createElement("br", null))) })) : (React.createElement(Button, { color: "primary", variant: "contained", component: "label" },
                    label || "Upload Media",
                    React.createElement("input", { hidden: true, accept: imageFileType || "image/*", type: "file", onChange: function (event) {
                            var e = event.target.files;
                            if (e && e[0]) {
                                setUploading(true);
                                dispatch(uploadFile({ file: e[0] }, {
                                    _emit: _emit,
                                    genericApiService: genericApiService,
                                    loaderStatePath: uploaderStateLoaderKey,
                                    s3KeyStatePath: "".concat(statePath, ".value"),
                                    fileNameStatePath: "".concat(statePath, ".name"),
                                    setValue: function (value) { return validateInput(value, validateInputOptions); },
                                    setStateValue: setStateValue,
                                    uploadCb: cb,
                                    onProgress: function (_a) {
                                        var loaded = _a.loaded, total = _a.total;
                                        setProgress((loaded / total) * 100);
                                    }
                                }));
                                if (onChange) {
                                    onChange({
                                        target: { value: inputValue }
                                    });
                                }
                            }
                            else {
                                validateInput(null, validateInputOptions);
                                if (onChange) {
                                    onChange({ target: { value: "" } });
                                }
                            }
                        } }))),
                uploading && (React.createElement(Box, { width: uploaderWidth || 246, mt: "3px", justifyContent: "space-between", display: "flex", alignItems: "center" },
                    React.createElement(LinearProgress, { style: { background: "hsl(0,0%,10%)", width: "100%" }, color: "primary", variant: progress ? "determinate" : "indeterminate", value: progress }),
                    React.createElement(Box, { color: "#fff" },
                        Math.floor(progress),
                        "%")))))));
            break;
        case CustomInputType.Radio:
            input = readonly ? (React.createElement(Typography, null, (selectOptions.find(function (item) { return item.value === inputValue; }) || {}).text)) : (React.createElement(RadioGroup, { row: true, value: "".concat(inputValue), style: { color: "primary" }, onChange: function (e) {
                    validateInput(e.target.value, __assign(__assign({}, validateInputOptions), { inputData: __assign(__assign({}, inputData), { validations: validations }) }));
                    if (onChange) {
                        onChange(e);
                    }
                } }, selectOptions.map(function (item) { return (React.createElement(FormControlLabel, { disabled: item.disabled, key: "".concat(item.value), value: "".concat(item.value), control: React.createElement(Radio, { color: "primary" }), label: React.createElement(Typography, { className: item.disabled ? classes.radioDisabled : "" }, item.text) })); })));
            break;
        case CustomInputType.Select:
            input = (React.createElement(FormControl, { size: "small", variant: "filled", fullWidth: true, hiddenLabel: true },
                React.createElement(Select, { classes: { root: classes.selectRoot }, value: inputValue, disableUnderline: true, disabled: selectOptions.length === 0 || readonly, displayEmpty: true, onChange: function (e) {
                        validateInput(e.target.value, __assign(__assign({}, validateInputOptions), { inputData: __assign(__assign({}, inputData), { validations: validations }) }));
                        if (onChange) {
                            onChange(e);
                        }
                    } },
                    React.createElement(MenuItem, { value: "", disabled: true }, label || inputData.placeholder),
                    (emptySelectOption ? [emptySelectOption] : []).concat(selectOptions).map(function (option) { return (React.createElement(MenuItem, __assign({ value: option.value }, (option.disabled && { disabled: true }), { key: "".concat(option.value) }), option.text)); }))));
            break;
        case CustomInputType.Editor:
            input = (React.createElement(TinyMCE, __assign({ value: inputValue }, (plugins && { plugins: plugins }), { onChange: function (text) {
                    validateInput(text, __assign(__assign({}, validateInputOptions), { inputData: __assign(__assign({}, inputData), { validations: validations }) }));
                } })));
            break;
        default:
            var inputTypeSpecificProps = textFieldInputTypeProps[inputType];
            if (inputType === CustomInputType.Number) {
                validations.isNumber = true;
            }
            input = (React.createElement(TextField, __assign({}, otherInputProps, inputTypeSpecificProps, { InputProps: __assign({ style: { color: theme.palette.primary.main }, disableUnderline: true }, InputProps), InputLabelProps: {
                    style: { color: theme.palette.primary.main }
                }, value: inputValue }, (inputType === CustomInputType.Number && {
                onWheel: function (e) { return e.target.blur(); }
            }), { onChange: function (e) {
                    validateInput(e.target.value, __assign(__assign({}, validateInputOptions), { inputData: __assign(__assign({}, inputData), { validations: validations }) }));
                    if (onChange) {
                        onChange(e);
                    }
                }, onKeyDown: function (e) {
                    if (onKeyPress) {
                        onKeyPress(e);
                    }
                }, onBlur: function (e) {
                    validateInput(e.target.value.trim(), __assign(__assign({}, validateInputOptions), { inputData: __assign(__assign({}, inputData), { validations: validations }) }));
                    if (onBlur) {
                        onBlur(e);
                    }
                }, color: "primary", error: displayError, fullWidth: true, variant: "filled", size: "small", label: inputData.label, placeholder: inputData.placeholder }, (readonly ? { readonly: true } : {}))));
            break;
    }
    if (displayError) {
        boxBorderProps.border = 1;
        boxBorderProps.borderColor = ERROR_FIELD_COLOR;
        boxClassName += classes.topLevelContainerWithError;
    }
    return (React.createElement(StylesProvider, { generateClassName: generateClassName },
        React.createElement(ThemeProvider, { theme: theme },
            React.createElement(Box, __assign({}, containerProps),
                React.createElement(Box, __assign({}, boxBorderProps, { className: boxClassName, display: "flex", flexDirection: "row" }),
                    input,
                    hasClearButton && (React.createElement(Box, { ml: 2 },
                        React.createElement(Tooltip, { title: "Clear selection" },
                            React.createElement(IconButton, { disabled: !selectOptions.length || readonly, onClick: function () {
                                    if (readonly) {
                                        dispatch(setStateValue({
                                            key: "".concat(statePath, ".readonly"),
                                            value: false
                                        }));
                                    }
                                    validateInput(defaultValue, validateInputOptions);
                                } },
                                React.createElement(Close, null)))))),
                displayError && (React.createElement(Typography, { className: "CustomInputError ".concat(classes.errorMessage), style: containerProps.width ? { width: containerProps.width } : {} }, error))))));
};
var templateObject_1;
//# sourceMappingURL=CustomInput.js.map